export default __webpack_public_path__ + "static/media/264.f2863030.png";